import React from 'react';
import { useLocaleContext } from '../../../context/LocaleContext';
import CButton from '../CButton';

import './style.scss';

const CAttachedFile = ({file}) => {
    const $locale = useLocaleContext();

    return (
        <div className="c-attached-file">
            <div className="c-attached-file__extension">
                {!file.link ? file.extension : 'LINK'}
            </div>
            <div className="c-attached-file__info">
                <div className="c-attached-file__info-filename">
                    {$locale.getProperty(file, 'title')}
                </div>
                <div className="c-attached-file__info-fileinfo">
                    {
                        !!file.size &&
                        <div className="c-attached-file__info-fileinfo-size">
                            {Math.round(file.size * 0.001)} Кб
                        </div>
                    }
                    <div className="c-attached-file__info-fileinfo-ext">
                        {!file.link ? file.extension : 'LINK'}
                    </div>
                </div>
            </div>
            <div className="c-attached-file__actions">
                <a
                    href={file.link ? file.link : file.url}
                    target="_blank"
                    className="c-attached-file__actions-link"
                >
                    {$locale.get('label.open')}
                </a>
            </div>
        </div>
    )
};

export default CAttachedFile;
